<template>
  <div style="height: 100%;">
    <div v-if="loader.getSystemInformationData || loader.selectCRMAgentFromCRMAgentGeneralSettingsView" style="position: absolute; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else-if="display.CRMAgent" style="height: 100%;">
      <v-card elevation="0" rounded="0" color="border" style="height: 100%; padding: 15px; overflow-y: auto; scrollbar-width: thin; -ms-overflow-style: none;">
        <v-card elevation="0" rounded="0" color="borderInner" style="padding: 15px; display: flex; flex-direction: column; gap: 15px;">
          <div style=" cursor: default; user-select: none;">
            <h3 style="font-weight: 500; margin: 0; letter-spacing: 0.5px;">Información general</h3>
          </div>
          <v-divider></v-divider>
          <div style="display: flex;"> 
            <div style="width: 15%; align-items: center; display: flex; justify-content: center; padding: 15px;">
              <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Cambiar foto de perfil" location="top">
                <template v-slot:activator="{ props }">
                  <img v-bind="props" @click="$refs.CRMAgentProfilePictureInput.click()" :src="input.CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" class="hoverableText" draggable="false" style="width: 100%; aspect-ratio: 1/1; border-radius: 50%; object-fit: cover; cursor: pointer;">
                  <input 
                    @change="uploadCRMAgentProfilePicture" 
                    ref="CRMAgentProfilePictureInput" 
                    accept="image/*"
                    type="file" 
                    style="display: none" 
                  />
                </template>
              </v-tooltip>
            </div>
            <div style="width: 80%; padding-left: 15px;">
              <v-menu v-model="navigation.CRMAgentColorMenuIsVisible" @update:model-value="updateCRMAgentColor" :scrim="true" :close-on-content-click="false">
                <template v-slot:activator="{ props }">
                  <v-text-field 
                    v-bind="props"
                    v-model="input.CRMAgentColor"
                    label="Color principal" 
                    variant="solo-filled" 
                    density="compact" 
                    readonly
                    hide-details
                    autocomplete="off"
                    :bg-color="input.CRMAgentColor"
                  ></v-text-field>
                </template>
                <v-color-picker v-model="input.CRMAgentColor" :mode="'rgb'" hide-inputs show-swatches :swatches="$assets.default.CRMWhatsappMessageColors" swatches-max-height="150"></v-color-picker>
              </v-menu>
              <v-menu v-model="navigation.CRMAgentFontColorMenuIsVisible" @update:model-value="updateCRMAgentFontColor" :scrim="true" :close-on-content-click="false">
                <template v-slot:activator="{ props }">
                  <v-text-field 
                    v-bind="props"
                    v-model="input.CRMAgentFontColor"
                    label="Color de texto" 
                    variant="solo-filled" 
                    density="compact" 
                    readonly
                    hide-details
                    autocomplete="off"
                    :bg-color="input.CRMAgentFontColor"
                    style="margin-top: 15px;"
                  ></v-text-field>
                </template>
                <v-color-picker v-model="input.CRMAgentFontColor" :mode="'rgb'" hide-inputs show-swatches :swatches="$assets.default.CRMWhatsappMessageColors" swatches-max-height="150"></v-color-picker>
              </v-menu>
            </div>
          </div>
        </v-card>
        <v-card elevation="0" rounded="0" color="borderInner" style="padding: 15px; display: flex; flex-direction: column; gap: 15px; margin-top: 15px;">
          <div style=" cursor: default; user-select: none;">
            <h3 style="font-weight: 500; margin: 0; letter-spacing: 0.5px;">Color de los mensajes</h3>
          </div>
          <v-divider></v-divider>
          <div style="display: flex; justify-content: flex-end; align-items: center;">
            <v-select 
              v-model="input.CRMAgentMessageColorTheme" 
              :items="display.CRMAgentMessageColorThemes" 
              @update:model-value="updateCRMAgentMessageColor()"
              append-inner-icon="mdi-palette-outline"
              item-title="CRMAgentMessageColorThemeName" 
              item-value="CRMAgentMessageColorThemeName"
              label="Temas de mensajes"
              variant="solo-filled"
              density="compact"
              hide-details
              autocomplete="off"
            >
              <template v-slot:selection="{ item }">
                <div style="display: flex; align-items: center; gap: 8px;">
                  <v-icon :color="input.CRMAgentOwnMessageColor" size="small">mdi-circle</v-icon>
                  <v-icon :color="input.CRMAgentContactMessageColor" size="small">mdi-circle</v-icon>
                  <p style="margin: 0;">{{ item.raw.CRMAgentMessageColorThemeName }}</p>
                </div>
              </template>
              <template v-slot:item="{ props, item }">
                <v-list-item v-bind="props">
                  <template v-slot:prepend>
                    <v-icon :color="item.raw.CRMAgentOwnMessageColor || display.CRMAgent.CRMAgentOwnMessageColor" size="small">mdi-circle</v-icon>
                    <v-icon :color="item.raw.CRMAgentContactMessageColor || display.CRMAgent.CRMAgentContactMessageColor" size="small">mdi-circle</v-icon>
                  </template>
                </v-list-item>
              </template>
            </v-select>
          </div>
          <div style="display: flex; justify-content: flex-end; align-items: center;">
            <v-menu v-model="navigation.CRMAgentOwnMessageColorMenuIsVisible" @update:model-value="updateCRMAgentOwnMessageColor" :scrim="true" :close-on-content-click="false">
              <template v-slot:activator="{ props }">
                <v-card v-bind="props" rounded="lg" :color="input.CRMAgentOwnMessageColor" class="hoverableText" style="width: 75%; padding: 10px 15px; word-break: break-word; display: inline-block; clear: both; position: relative; user-select: none;">
                  <p style="margin: 0; font-size: 14px; line-height: 1.4; white-space: pre-wrap; word-wrap: break-word;">Mensaje enviado desde el sistema</p>
                </v-card>
              </template>
              <v-color-picker 
                v-model="input.CRMAgentOwnMessageColor" 
                :mode="'rgb'" 
                hide-inputs 
                show-swatches
                :swatches="$assets.default.CRMWhatsappMessageColors"
                swatches-max-height="150"
                ></v-color-picker>
            </v-menu>
          </div>
          <div style="display: flex; justify-content: flex-start; align-items: center;">
            <v-menu v-model="navigation.CRMAgentContactMessageColorMenuIsVisible" @update:model-value="updateCRMAgentContactMessageColor" :scrim="true" :close-on-content-click="false">
              <template v-slot:activator="{ props }">
                <v-card v-bind="props" @click="input.CRMAgentContactMessageColorBackup = input.CRMAgentContactMessageColor" rounded="lg" :color="input.CRMAgentContactMessageColor" class="hoverableText" style="width: 75%; padding: 10px 15px; word-break: break-word; display: inline-block; clear: both; position: relative; user-select: none;">
                  <p style="margin: 0; font-size: 14px; line-height: 1.4; white-space: pre-wrap; word-wrap: break-word;">Mensaje enviado por el contacto</p>
                </v-card>
              </template>
              <v-color-picker 
                v-model="input.CRMAgentContactMessageColor" 
                :mode="'rgb'" 
                hide-inputs 
                show-swatches
                :swatches="$assets.default.CRMWhatsappMessageColors"
                swatches-max-height="150"
                ></v-color-picker>
            </v-menu>
          </div>
        </v-card>
        
        <v-card elevation="0" rounded="0" color="borderInner" style="padding: 15px; display: flex; flex-direction: column; gap: 15px; margin-top: 15px;">
          <div style="cursor: default; user-select: none;">
            <h3 style="font-weight: 500; margin: 0; letter-spacing: 0.5px;">Fondo de pantalla de las conversaciones</h3>
          </div>
          <v-divider></v-divider>
          <div style="width: 100%; max-height: 450px; height: 450px; min-height: 450px;">
            <v-tooltip :disabled="systemInformationData.tooltipDisabled" text="Cambiar fondo de pantalla de las conversaciones" location="top">
              <template v-slot:activator="{ props }">
                <img v-bind="props" @click="$refs.CRMAgentBackgroundInput.click()" :src="input.CRMAgentBackgroundURL || require('@/assets/images/CRMWhatsappConversationBackground.png')" draggable="false" class="hoverableText" style="width: 100%; height: 100%; object-fit: cover; cursor: pointer;">
              </template>
            </v-tooltip>
            <input 
              @change="uploadCRMAgentBackground" 
              ref="CRMAgentBackgroundInput" 
              accept="image/*"
              type="file" 
              style="display: none" 
            />
          </div>
        </v-card>
      </v-card>      
    </div>
  </div>
</template>

<style scoped>
</style>

<script>
import { systemInformation } from '@/utilities/systemInformation';
export default {
  inject: ['$generalFunctions', '$displayFunctions', '$assets'],
  components: {},
  data: () => ({
    input: 
    {
      CRMAgentProfilePictureURL: null,
      CRMAgentColor: null,
      CRMAgentFontColor: null,
      CRMAgentBackgroundURL: null,
      CRMAgentMessageColorTheme: null,
      CRMAgentOwnMessageColor: null,
      CRMAgentContactMessageColor: null
    },
    display: 
    {
      CRMAgent: null,
      CRMAgentMessageColorThemes: 
      [
        {CRMAgentMessageColorThemeName: 'Personalizado', CRMAgentOwnMessageColor: null, CRMAgentContactMessageColor: null},
        {CRMAgentMessageColorThemeName: 'Tema 1', CRMAgentOwnMessageColor: '#e6f3ff', CRMAgentContactMessageColor: '#f0f2f5'},
        {CRMAgentMessageColorThemeName: 'Tema 2', CRMAgentOwnMessageColor: '#f0f2ff', CRMAgentContactMessageColor: '#eef2f0'},
        {CRMAgentMessageColorThemeName: 'Tema 3', CRMAgentOwnMessageColor: '#ffe8e0', CRMAgentContactMessageColor: '#f5f0ed'},
        {CRMAgentMessageColorThemeName: 'Tema 4', CRMAgentOwnMessageColor: '#e8f5e8', CRMAgentContactMessageColor: '#f0f5f0'},
      ]
    },
    navigation: 
    {
      CRMAgentID: null,
      CRMAgentColorMenuIsVisible: false,
      CRMAgentFontColorMenuIsVisible: false,
      CRMAgentOwnMessageColorMenuIsVisible: false,
      CRMAgentContactMessageColorMenuIsVisible: false,
    },
    loader: 
    {
      getSystemInformationData: false,
      selectCRMAgentFromCRMAgentGeneralSettingsView: false
    },
    systemInformationData: 
    {
      CRMAccountID: null,
      tooltipDisabled: false,
      updateSubscription: null
    }
  }),

  watch: 
  {
    'input.CRMAgentOwnMessageColor'(){
      this.input.CRMAgentMessageColorTheme = this.display.CRMAgentMessageColorThemes.find(CRMAgentMessageColorTheme => CRMAgentMessageColorTheme.CRMAgentOwnMessageColor == this.input.CRMAgentOwnMessageColor && CRMAgentMessageColorTheme.CRMAgentContactMessageColor == this.input.CRMAgentContactMessageColor) ? this.display.CRMAgentMessageColorThemes.find(CRMAgentMessageColorTheme => CRMAgentMessageColorTheme.CRMAgentOwnMessageColor == this.input.CRMAgentOwnMessageColor && CRMAgentMessageColorTheme.CRMAgentContactMessageColor == this.input.CRMAgentContactMessageColor).CRMAgentMessageColorThemeName : 'Personalizado';
    },
    'input.CRMAgentContactMessageColor'(){
      this.input.CRMAgentMessageColorTheme = this.display.CRMAgentMessageColorThemes.find(CRMAgentMessageColorTheme => CRMAgentMessageColorTheme.CRMAgentOwnMessageColor == this.input.CRMAgentOwnMessageColor && CRMAgentMessageColorTheme.CRMAgentContactMessageColor == this.input.CRMAgentContactMessageColor) ? this.display.CRMAgentMessageColorThemes.find(CRMAgentMessageColorTheme => CRMAgentMessageColorTheme.CRMAgentOwnMessageColor == this.input.CRMAgentOwnMessageColor && CRMAgentMessageColorTheme.CRMAgentContactMessageColor == this.input.CRMAgentContactMessageColor).CRMAgentMessageColorThemeName : 'Personalizado';
    }
  },

  methods: {
    async selectCRMAgentFromCRMAgentGeneralSettingsView() {
      this.loader.selectCRMAgentFromCRMAgentGeneralSettingsView = true;
      const selectCRMAgentFromCRMAgentGeneralSettingsViewRequestQuery = 
      {
        'localStorage':
        {
          'CRMAccountID': this.systemInformationData.CRMAccountID,
          'CRMAgentID': this.navigation.CRMAgentID
        }
      };
      const selectCRMAgentFromCRMAgentGeneralSettingsViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/selectCRMAgentFromCRMAgentGeneralSettingsView', selectCRMAgentFromCRMAgentGeneralSettingsViewRequestQuery);
      if (selectCRMAgentFromCRMAgentGeneralSettingsViewResult.success) {
        this.display.CRMAgent = selectCRMAgentFromCRMAgentGeneralSettingsViewResult.result;
        this.input.CRMAgentProfilePictureURL = this.display.CRMAgent.CRMAgentProfilePictureURL;
        this.input.CRMAgentColor = this.display.CRMAgent.CRMAgentColor;
        this.input.CRMAgentFontColor = this.display.CRMAgent.CRMAgentFontColor;
        this.input.CRMAgentBackgroundURL = this.display.CRMAgent.CRMAgentBackgroundURL;
        this.input.CRMAgentMessageColorTheme = this.display.CRMAgent.CRMAgentMessageColorTheme;
        this.input.CRMAgentOwnMessageColor = this.display.CRMAgent.CRMAgentOwnMessageColor;
        this.input.CRMAgentContactMessageColor = this.display.CRMAgent.CRMAgentContactMessageColor;
        this.loader.selectCRMAgentFromCRMAgentGeneralSettingsView = false;
      } else {
        this.$root.notificationDialog.showSystemNotificationDialog('selectCRMAgentFromCRMAgentGeneralSettingsView_error', 'error', 'Ha ocurrido un error inesperado al abrir la configuración general del agente, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
      }
    },
    uploadCRMAgentProfilePicture(CRMAgentProfilePictureUploadEvent) {
      try {
        const CRMAgentProfilePicture = CRMAgentProfilePictureUploadEvent.target.files[0];
        if (!CRMAgentProfilePicture) return;
        const CRMAgentProfilePictureReader = new FileReader();
        CRMAgentProfilePictureReader.onload = async () => {
          this.input.CRMAgentProfilePictureURL = CRMAgentProfilePictureReader.result;
          const updateCRMAgentProfilePictureRequestQuery = 
          {
            'localStorage': 
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.navigation.CRMAgentID,
            },
            'CRMAgentProfilePictureFile': this.input.CRMAgentProfilePictureURL
          };
          const updateCRMAgentProfilePictureResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/updateCRMAgentProfilePicture', updateCRMAgentProfilePictureRequestQuery);
          if (updateCRMAgentProfilePictureResult.success) {
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentProfilePicture_success', 'success', 'La foto de perfil ha sido actualizada exitosamente', null, true);
          } else {
            this.input.CRMAgentProfilePictureURL = this.display.CRMAgent.CRMAgentProfilePictureURL;
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentProfilePicture_error', 'error', 'Ha ocurrido un error inesperado al actualizar la foto de perfil, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
        }
        CRMAgentProfilePictureReader.readAsDataURL(CRMAgentProfilePicture);
      } catch { 
        this.input.CRMAgentProfilePictureURL = this.display.CRMAgent.CRMAgentProfilePictureURL;
        this.$root.notificationDialog.showSystemNotificationDialog('uploadCRMAgentProfilePicture_error', 'error', 'Ha ocurrido un error inesperado al actualizar la foto de perfil, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
      }
    },
    async updateCRMAgentColor() {
      if (!this.navigation.CRMAgentColorMenuIsVisible && this.input.CRMAgentColor != this.display.CRMAgent.CRMAgentColor) {
        const updateCRMAgentColorRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,  
            'CRMAgentID': this.navigation.CRMAgentID,
          },
          'CRMAgentColor': this.input.CRMAgentColor
        };
        const updateCRMAgentColorResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/updateCRMAgentColor', updateCRMAgentColorRequestQuery);
        if (updateCRMAgentColorResult.success) {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentColor_success', 'success', 'El color principal ha sido actualizado exitosamente', null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentColor_error', 'error', 'Ha ocurrido un error inesperado al actualizar el color principal, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.input.CRMAgentColor = this.display.CRMAgent.CRMAgentColor;
        }
      }
    },
    async updateCRMAgentFontColor() {
      if (!this.navigation.CRMAgentFontColorMenuIsVisible && this.input.CRMAgentFontColor != this.display.CRMAgent.CRMAgentFontColor) {
        const updateCRMAgentFontColorRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.navigation.CRMAgentID,
          },
          'CRMAgentFontColor': this.input.CRMAgentFontColor
        };
        const updateCRMAgentFontColorResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/updateCRMAgentFontColor', updateCRMAgentFontColorRequestQuery);
        if (updateCRMAgentFontColorResult.success) {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentFontColor_success', 'success', 'El color de texto ha sido actualizado exitosamente', null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentFontColor_error', 'error', 'Ha ocurrido un error inesperado al actualizar el color de texto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.input.CRMAgentFontColor = this.display.CRMAgent.CRMAgentFontColor;
        }
      }
    },
    async updateCRMAgentMessageColor() {
      this.input.CRMAgentOwnMessageColor = this.display.CRMAgentMessageColorThemes.find(CRMAgentMessageColorTheme => CRMAgentMessageColorTheme.CRMAgentMessageColorThemeName == this.input.CRMAgentMessageColorTheme).CRMAgentOwnMessageColor || this.display.CRMAgent.CRMAgentOwnMessageColor; 
      this.input.CRMAgentContactMessageColor = this.display.CRMAgentMessageColorThemes.find(CRMAgentMessageColorTheme => CRMAgentMessageColorTheme.CRMAgentMessageColorThemeName == this.input.CRMAgentMessageColorTheme).CRMAgentContactMessageColor || this.display.CRMAgent.CRMAgentContactMessageColor; 
      const updateCRMAgentMessageColorRequestQuery = 
      {
        'localStorage': 
        {
          'CRMAccountID': this.systemInformationData.CRMAccountID,
          'CRMAgentID': this.navigation.CRMAgentID,
        },
        'CRMAgentOwnMessageColor': this.input.CRMAgentOwnMessageColor,
        'CRMAgentContactMessageColor': this.input.CRMAgentContactMessageColor
      };
      const updateCRMAgentMessageColorResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/updateCRMAgentMessageColor', updateCRMAgentMessageColorRequestQuery);
      if (updateCRMAgentMessageColorResult.success) {
        this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentMessageColor_success', 'success', 'El color de los mensajes ha sido actualizado exitosamente', null, true);
      } else {
        this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentMessageColor_error', 'error', 'Ha ocurrido un error inesperado al actualizar el color de los mensajes, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        this.input.CRMAgentOwnMessageColor = this.display.CRMAgent.CRMAgentOwnMessageColor;
        this.input.CRMAgentContactMessageColor = this.display.CRMAgent.CRMAgentContactMessageColor;
      }
    },
    async updateCRMAgentOwnMessageColor() {
      if (!this.navigation.CRMAgentOwnMessageColorMenuIsVisible && this.input.CRMAgentOwnMessageColor != this.display.CRMAgent.CRMAgentOwnMessageColor) {
        const updateCRMAgentOwnMessageColorRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.navigation.CRMAgentID,
          },
          'CRMAgentOwnMessageColor': this.input.CRMAgentOwnMessageColor
        };
        const updateCRMAgentOwnMessageColorResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/updateCRMAgentOwnMessageColor', updateCRMAgentOwnMessageColorRequestQuery);
        if (updateCRMAgentOwnMessageColorResult.success) {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentOwnMessageColor_success', 'success', 'El color del mensaje del agente ha sido actualizado exitosamente', null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentOwnMessageColor_error', 'error', 'Ha ocurrido un error inesperado al actualizar el color del mensaje del agente, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.input.CRMAgentOwnMessageColor = this.display.CRMAgent.CRMAgentOwnMessageColor;
        }
      }
    },
    async updateCRMAgentContactMessageColor() {
      if (!this.navigation.CRMAgentContactMessageColorMenuIsVisible && this.input.CRMAgentContactMessageColor != this.display.CRMAgent.CRMAgentContactMessageColor) {
        const updateCRMAgentContactMessageColorRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.navigation.CRMAgentID,
          },
          'CRMAgentContactMessageColor': this.input.CRMAgentContactMessageColor
        };
        const updateCRMAgentContactMessageColorResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/updateCRMAgentContactMessageColor', updateCRMAgentContactMessageColorRequestQuery);
        if (updateCRMAgentContactMessageColorResult.success) {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentContactMessageColor_success', 'success', 'El color del mensaje del contacto ha sido actualizado exitosamente', null, true);
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentContactMessageColor_error', 'error', 'Ha ocurrido un error inesperado al actualizar el color del mensaje del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.input.CRMAgentContactMessageColor = this.display.CRMAgent.CRMAgentContactMessageColor;
        }
      }
    },
    uploadCRMAgentBackground(CRMAgentBackgroundUploadEvent) {
      const CRMAgentBackgroundBackup = this.input.CRMAgentBackgroundURL;
      try {
        const CRMAgentBackground = CRMAgentBackgroundUploadEvent.target.files[0];
        if (!CRMAgentBackground) return;
        const CRMAgentBackgroundReader = new FileReader();
        CRMAgentBackgroundReader.onload = async () => {
          this.input.CRMAgentBackgroundURL = CRMAgentBackgroundReader.result;
          const updateCRMAgentBackgroundRequestQuery = 
          {
            'localStorage': 
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.navigation.CRMAgentID,
            },
            'CRMAgentBackgroundFile': this.input.CRMAgentBackgroundURL
          };
          const updateCRMAgentBackgroundResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/updateCRMAgentBackground', updateCRMAgentBackgroundRequestQuery);
          if (updateCRMAgentBackgroundResult.success) {
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentBackground_success', 'success', 'El fondo de pantalla de las conversaciones ha sido actualizado exitosamente', null, true);
          } else {
            this.input.CRMAgentBackgroundURL = CRMAgentBackgroundBackup;
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentBackground_error', 'error', 'Ha ocurrido un error inesperado al actualizar el fondo de pantalla de las conversaciones, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          }
        }
        CRMAgentBackgroundReader.readAsDataURL(CRMAgentBackground);
      } catch {
        this.input.CRMAgentBackgroundURL = CRMAgentBackgroundBackup;
        this.$root.notificationDialog.showSystemNotificationDialog('uploadCRMAgentBackground_error', 'error', 'Ha ocurrido un error inesperado al actualizar la imagen de fondo, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
      }
    },
    async getSystemInformationData() {
      try {
        this.loader.getSystemInformationData = true;
        systemInformation.setGeneralFunctions(this.$generalFunctions.default);
        const systemInformationResult = await systemInformation.startup();
        if (systemInformationResult.success){
          this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
          this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
          this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
            this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
          });
          this.loader.getSystemInformationData = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      } catch {
        this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
      }
    }
  },

  async mounted() {
    if (this.$route.params.CRMAgentID) this.navigation.CRMAgentID = this.$route.params.CRMAgentID;
    await this.getSystemInformationData();
    await this.selectCRMAgentFromCRMAgentGeneralSettingsView();
  },

  beforeUnmount() {
    if (this.systemInformationData.updateSubscription) {
      systemInformation.unsubscribeFromUpdate(this.systemInformationData.updateSubscription);
      this.systemInformationData.updateSubscription = null;
    }
  }
}
</script>
